import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/brand/marketing creatives.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const MarketingCreatives = () => {
  const heroData = {
    title: "High-Impact Marketing Creative Design",
    description: "Capture attention and drive action with compelling marketing creatives that convert. We design scroll-stopping visuals for digital campaigns, social media, print, and all marketing channels.",
    image: img13,
    imageAlt: "Marketing Creatives",
    features: [
      "Social media graphics",
      "Ad campaign design",
      "Print materials",
      "Email templates",
      "Infographics",
      "Video thumbnails",
    ],
    pillars: [
      "Attention-grabbing design that stops the scroll and drives clicks",
      "Brand-consistent creatives that reinforce identity across channels",
      "Performance-optimized visuals that convert viewers into customers",
    ],
  };

  const journeySteps = [
    {
      title: "Brief & Strategy",
      description: "We understand your campaign goals, target audience, and key messages to create strategic creative direction.",
      details: ["Campaign objectives", "Audience analysis", "Message hierarchy", "Competitive review", "Success metrics", "Creative strategy"],
    },
    {
      title: "Concept Development",
      description: "Our team develops multiple creative concepts and visual approaches that align with your campaign strategy.",
      details: ["Concept ideation", "3-4 design directions", "Copy integration", "Visual storytelling", "Brand alignment", "Format variations"],
    },
    {
      title: "Design Execution",
      description: "We create polished, production-ready designs optimized for each platform and channel with attention to detail.",
      details: ["High-res designs", "Platform optimization", "Multiple formats", "A/B test variations", "Responsive versions", "Animation & motion"],
    },
    {
      title: "Delivery & Support",
      description: "Comprehensive delivery of all assets with source files and ongoing support for campaign optimization and iterations.",
      details: ["All file formats", "Source files", "Usage guidelines", "Quick revisions", "Performance feedback", "Campaign support"],
    },
  ];

  const capabilities = [
    {
      title: "Social Media Creatives",
      content:
        "Scroll-stopping graphics for Instagram, Facebook, LinkedIn, Twitter, TikTok, and all social platforms with optimal sizing.",
    },
    {
      title: "Digital Ad Campaigns",
      content:
        "Google Ads, Facebook Ads, display banners, and paid media creatives designed for maximum CTR and conversion.",
    },
    {
      title: "Print Marketing",
      content:
        "Brochures, flyers, posters, billboards, and traditional print materials with professional production specifications.",
    },
    {
      title: "Email & Web Graphics",
      content:
        "Email templates, landing page graphics, web banners, and digital touchpoints that drive engagement and action.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "3.5×", label: "Average CTR improvement" },
      { value: "65%", label: "Higher engagement rate" },
      { value: "200+", label: "Assets per campaign" },
    ],
    description: "We create marketing creatives that significantly outperform industry benchmarks, driving higher engagement, click-through rates, and campaign ROI.",
  };

  const outcomesData = {
    description: "We deliver comprehensive creative assets that capture attention, communicate your message effectively, and drive measurable campaign results.",
    outcomes: [
      "Platform-optimized social media graphics",
      "Multi-format ad campaign designs",
      "Print-ready marketing collateral",
      "Responsive email templates",
      "Attention-grabbing infographics",
      "Video thumbnails and motion graphics",
    ],
  };

  const whyChooseUs = [
    {
      title: "Performance-Driven Design",
      content:
        "We design for conversion, using proven principles and A/B testing to maximize campaign effectiveness and ROI.",
    },
    {
      title: "Fast Turnaround",
      content:
        "Get initial concepts within 48 hours and final deliverables in 5-7 days—perfect for fast-moving campaigns.",
    },
    {
      title: "Unlimited Variations",
      content:
        "We create multiple formats, sizes, and variations so you have everything you need for every platform and channel.",
    },
    {
      title: "Campaign Support",
      content:
        "Ongoing support throughout your campaign with quick iterations, optimizations, and new creative as needed.",
    },
  ];

  const faqs = [
    {
      q: "What types of marketing creatives do you design?",
      a: "We design comprehensive marketing assets including social media graphics, digital ad campaigns (Google, Facebook, display), email templates, infographics, brochures, flyers, posters, billboards, presentation decks, and video thumbnails. All optimized for their specific platform and purpose."
    },
    {
      q: "How quickly can you deliver marketing creatives?",
      a: "For standard projects, you'll receive initial concepts within 48 hours and final deliverables in 5-7 days. We also offer rush services for urgent campaigns with 24-48 hour turnaround. Our fast process doesn't compromise quality—we maintain high design standards at every speed."
    },
    {
      q: "Do you provide different sizes for various platforms?",
      a: "Yes! We create all necessary size variations for each platform—Instagram posts/stories/reels, Facebook ads, Google display ads, LinkedIn, Twitter, Pinterest, TikTok, and more. You'll receive optimized formats for every channel in your campaign."
    },
    {
      q: "Can you help with ongoing campaign creative needs?",
      a: "Absolutely! We offer monthly retainer packages for ongoing creative support. This includes new creative concepts, A/B test variations, seasonal updates, performance optimization, and quick iterations based on campaign results. Perfect for maintaining fresh, high-performing marketing materials."
    }
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Marketing Creatives"}
            pagesub={"Branding & Design"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Creative Development Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default MarketingCreatives;
